import React from "react";
import { Card } from "react-bootstrap";
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useLocation} from 'react-router-dom'
//icons
import { BiCalendarCheck } from 'react-icons/bi';
import { MdPlace } from 'react-icons/md';
//helpers
import { convertDateToDDMMYYYY } from "../../helpers";
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//styles
import "../../assets/css/event.scss";


const CardEvent = (props) => {
  const location = useLocation()
  const { t } = useTranslation(['schedule']);
  const { start_date, end_date, image, body, title, place, id, type_schedule } = props.event;
  const { assignedLibrary} = useAssignedLibrary();


  return (
    <Card
      className={`${location.pathname === `/${assignedLibrary}/agenda` ? 'card-event' : 'card-event-home'} card-event-general ${props.isMobile && 'card-mobile'}`}
    >
      <div className="p-0 card-event-general__container-image">
        <Card.Link href={`/${assignedLibrary}/agenda/${id}`}>
        <img
          alt={title || t('imageactivity')}
          src={`${image}`}
        />
        </Card.Link>
      </div>
      <Card.Body className="pb-0">
        {
          type_schedule && (
            <Card.Subtitle
              className="mb-2 text-muted orange text-uppercase "
              tag="h6"
            >
              {type_schedule.name}
            </Card.Subtitle>
          )
        }
        <Card.Title tag="h5">
          <Card.Link href={`/${assignedLibrary}/agenda/${id}`} className="text-dark text-decoration-none">
            {title}
          </Card.Link>
        </Card.Title>
      </Card.Body>
      <Card.Body className="pb-0 align-items-center align-items-md-start">
        <BiCalendarCheck className="orange" size={25} />
        <span className="px-2 ml-2 font-weight-bold mt-1 font-size-14">{convertDateToDDMMYYYY(start_date)} </span>
        {start_date !== end_date && <span className="font-size-14 mt-1">-</span>}
        <span className="px-2 font-weight-bold mt-1 font-size-14">&nbsp;{start_date !== end_date && convertDateToDDMMYYYY(end_date)}</span>
      </Card.Body>
      {( place !== "" && place !== "null"  ) && <Card.Body className=" pb-0">
        <MdPlace className="orange" size={25} />
        <span className="ml-2 text-uppercase font-weight-bold font-size-14">{place}</span>
      </Card.Body>}
      <Card.Body className="rounded-bottom-15">
        <div className="mt-2 mb-3 text  card-event-general__container-body" dangerouslySetInnerHTML={{ __html: body }} />
      </Card.Body>
    </Card>
  );
};

CardEvent.propTypes = {
  event: PropTypes.shape({
    start_date: PropTypes.string,
    end_date: PropTypes.string || PropTypes.number,
    image: PropTypes.string,
    title: PropTypes.string,
    place: PropTypes.string,
    id: PropTypes.number,
    type_schedule: PropTypes.shape({
      name: PropTypes.string
    })
  }),
  isMobile: PropTypes.bool
};

export default CardEvent;
